import ReactDOM from 'react-dom'
import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

const Modal = ({ show, close, title, children, className, renderActions }) => {

    const handleEsc = (e) => {
        if (e.key === 'Escape') {
            close()
        }
    }

  useEffect(() => {
    document.body.addEventListener('keyup', handleEsc)

    return () => {
        document.body.removeEventListener('keyup', handleEsc)
    }
  }, [])

  return ReactDOM.createPortal(
    <>
      { show &&
        <>
          <div onClick={close} className='modal-background'></div>
          <div
            className={`modal-inner${className ? ` ${className}` : ''}`}
          >
            <div className='modal-header'>
              <div className='modal-header--inner'>
                <button className='modal-close' onClick={close}></button>
                <h2 className='modal-title'>{ title }</h2>
              </div>
            </div>
            <div className='modal-content'>{ children }</div>
            {
              renderActions ?
              renderActions()
              :
              <></>
            }
          </div>
        </>
      }
    </>,
    document.getElementById('modal'),
  )
}

Modal.propTypes = {
    show: PropTypes.bool,
}

export default Modal
